/**
 * batch-71 profiel-in-beeld (FO-538) - tekenbreedtes van het ontwerp-lettertype.
 *
 * Het "Profiel in beeld"-ontwerp staat in Tahoma (regular + bold). Om in de editor
 * vooraf te kunnen zeggen of een tekst op de slide past, en om in de generator
 * dezelfde beslissing te nemen, rekenen we met de echte tekenbreedtes in plaats van
 * een gemiddelde. Dit bestand bevat ALLEEN breedtes (duizendsten van een em, uit de
 * hmtx-tabel), geen letterontwerpen: er wordt hier geen font meegeleverd.
 *
 * Bereik: U+0020-U+007E en U+00A0-U+017F; de overige veelgebruikte leestekens staan
 * in de EXTRA-tabellen. Een onbekend teken telt als de gemiddelde breedte.
 */
const BEREIK_1_START = 0x20
const BEREIK_1_EIND = 0x7e
const BEREIK_2_START = 0xa0
const BEREIK_2_EIND = 0x17f

const REGULAR: readonly number[] = [
  313,332,401,728,546,977,674,211,383,383,546,728,303,363,303,382,546,546,546,546,546,546,546,546,
  546,546,354,354,728,728,728,474,909,600,589,601,678,561,521,667,675,373,417,588,498,771,667,708,
  551,708,621,557,584,656,597,902,581,576,559,383,382,383,728,546,546,525,553,461,553,526,318,553,
  558,229,282,498,229,840,558,543,553,553,360,446,334,558,498,742,495,498,444,480,382,480,728,313,
  332,546,546,546,546,382,546,546,929,493,573,728,363,929,546,471,728,493,493,546,568,546,354,546,
  493,493,573,1000,1000,1000,474,600,600,600,600,600,600,913,601,561,561,561,561,373,373,373,373,698,
  667,708,708,708,708,708,728,708,656,656,656,656,576,565,548,525,525,525,525,525,525,880,461,526,
  526,526,526,229,229,229,229,546,558,543,543,543,543,543,728,543,558,558,558,558,498,553,498,600,
  525,600,525,600,525,601,461,601,461,601,461,601,461,678,687,698,573,561,526,561,526,561,526,561,
  526,561,526,667,553,667,553,667,553,667,553,675,558,715,578,373,229,373,229,373,229,373,229,373,
  229,731,516,417,282,588,498,498,498,229,498,229,498,361,498,445,518,274,667,558,667,558,667,558,
  692,667,558,708,543,708,543,708,543,977,909,621,360,621,360,621,360,557,446,557,446,557,446,557,
  446,584,334,584,468,584,339,656,558,656,558,656,558,656,558,656,558,656,558,902,742,576,498,576,
  559,444,559,444,559,444,254,
]

const BOLD: readonly number[] = [
  293,343,489,818,637,1199,781,275,454,454,637,818,313,431,313,577,637,637,637,637,637,637,637,637,
  637,637,363,363,818,818,818,566,920,685,686,667,757,615,581,745,764,483,500,696,572,893,771,770,
  657,770,726,633,612,739,675,1028,685,670,623,454,577,454,818,637,546,599,632,527,629,594,382,629,
  640,302,363,603,302,954,640,617,629,629,434,515,416,640,579,890,604,576,526,623,637,623,818,293,
  343,637,637,637,637,637,637,546,929,508,703,818,431,929,637,520,818,539,539,546,651,637,363,546,
  539,539,703,1128,1128,1128,566,685,685,685,685,685,685,989,667,615,615,615,615,483,483,483,483,774,
  771,770,770,770,770,770,818,770,739,739,739,739,670,659,646,599,599,599,599,599,599,937,527,594,
  594,594,594,302,302,302,302,620,640,617,617,617,617,617,818,617,640,640,640,640,576,629,576,685,
  599,685,599,685,599,667,527,667,527,667,527,667,527,757,817,774,625,615,594,615,594,615,594,615,
  594,615,594,745,629,745,629,745,629,745,629,764,640,782,635,483,302,483,302,483,302,483,302,483,
  302,940,648,500,363,696,603,603,572,302,572,302,572,490,572,487,589,335,771,640,771,640,771,640,
  742,771,640,770,617,770,617,770,617,1037,985,726,434,726,434,726,434,633,515,633,515,633,515,633,
  515,612,416,612,619,612,416,739,640,739,640,739,640,739,640,739,640,739,640,1028,890,670,576,670,
  623,526,623,526,623,526,322,
]

const EXTRA_REGULAR: Readonly<Record<number, number>> = {8211: 546, 8212: 909, 8216: 211, 8217: 211, 8220: 401, 8221: 401, 8226: 455, 8230: 817, 8364: 546, 8722: 728}
const EXTRA_BOLD: Readonly<Record<number, number>> = {8211: 637, 8212: 909, 8216: 275, 8217: 275, 8220: 489, 8221: 489, 8226: 637, 8230: 1000, 8364: 637, 8722: 818}

/** Breedte van de vinkjes-glyphs (Segoe UI Symbol), in duizendsten van een em. */
const GLYPH_VINKJE = 861
const ONBEKEND_REGULAR = 560
const ONBEKEND_BOLD = 640

/** Breedte van een teken in em (dus: maal de puntgrootte = breedte in punten). */
export function profielTekenBreedte(codepunt: number, vet: boolean): number {
  if (codepunt === 0x2610 || codepunt === 0x2612) return GLYPH_VINKJE / 1000
  const tabel = vet ? BOLD : REGULAR
  let waarde: number | undefined
  if (codepunt >= BEREIK_1_START && codepunt <= BEREIK_1_EIND) {
    waarde = tabel[codepunt - BEREIK_1_START]
  } else if (codepunt >= BEREIK_2_START && codepunt <= BEREIK_2_EIND) {
    waarde = tabel[BEREIK_1_EIND - BEREIK_1_START + 1 + (codepunt - BEREIK_2_START)]
  } else {
    waarde = (vet ? EXTRA_BOLD : EXTRA_REGULAR)[codepunt]
  }
  if (waarde === undefined || waarde === 0) return (vet ? ONBEKEND_BOLD : ONBEKEND_REGULAR) / 1000
  return waarde / 1000
}

/** Regelhoogte van Tahoma zonder expliciete regelafstand (ascent + descent), in em. */
export const PROFIEL_REGELHOOGTE_EM = 1.207

/**
 * Van welke lettertypen dit bestand de echte breedtes heeft (sleutel in kleine letters), en
 * voor welke tekens: `null` = een volledige tabel, anders alleen deze codepunten. Segoe UI
 * Symbol staat er alleen voor de vakjes in; het ontwerp gebruikt hem nergens anders voor.
 *
 * Elk ander lettertype rekent `profielTekenBreedte` met de breedtes van Tahoma. Dat blijft zo
 * (de meting verandert niet), maar de uitkomst is dan een schatting en dat moet zichtbaar
 * gemeld worden: zie `profielOngemetenLettertypen` en de SCHATTING-waarschuwing in profiel-fit.
 */
const GEMETEN_LETTERTYPEN: ReadonlyMap<string, ReadonlySet<number> | null> = new Map<string, ReadonlySet<number> | null>([
  ['tahoma', null],
  ['segoe ui symbol', new Set([0x2610, 0x2612])],
])

/**
 * Kent dit bestand de tekenbreedtes van dit lettertype?
 *
 * Zonder `tekst`: is er een breedtetabel voor dit lettertype (ook een gedeeltelijke). Met
 * `tekst`: zijn alle tekens van die tekst gemeten. Witruimte telt niet mee: die is in elk
 * lettertype smal en de fit rekent er al met Tahoma voor (de spaties achter een vakje).
 */
export function profielLettertypeGemeten(lettertype: string, tekst?: string): boolean {
  const tekens = GEMETEN_LETTERTYPEN.get(lettertype.trim().toLowerCase())
  if (tekens === undefined) return false
  if (tekens === null || tekst === undefined) return true
  for (const teken of tekst) {
    if (/\s/.test(teken)) continue
    if (!tekens.has(teken.codePointAt(0) ?? 0)) return false
  }
  return true
}
